<template>
  <v-card
    outlined
    class="mb-5"
    min-height="100"
  >
    <v-card-text>
      <v-row no-gutters>
        <v-col cols="12" md="3">
            <v-row>
              <b>{{ item.budgetStatistic.elevator.name }}</b>
            </v-row>
            <v-row>
              <b>{{ $t('display/elevator:budget-statistic.monthly-cost') }}</b>: {{ monthlyCost() }}
            </v-row>
            <v-row>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    :color="color"
                    v-bind="attrs"
                    v-on="on"
                  >
                    online_prediction
                  </v-icon>
                </template>
                <span>{{ text }}</span>
              </v-tooltip>
            </v-row>
        </v-col>

        <v-col cols="12" md="6">
          <v-row>
            <v-col><b>{{ $t('display/elevator:budget-statistic.revenue') }}:</b> {{ getRevenue() }} €</v-col>
            <v-col><b>{{ $t('display/elevator:budget-statistic.budget-ads') }}:</b> {{ getBudgetAds() }} %</v-col>
          </v-row>
          <v-row>
            <v-col><b>{{ $t('display/elevator:budget-statistic.provision') }}:</b> {{ getProvision() }} €</v-col>
            <v-col><b>{{ $t('display/elevator:budget-statistic.inhouse-ads') }}:</b> {{ getInhouse()}} %</v-col>
          </v-row>
          <v-row>
            <v-col><b>{{ $t('display/elevator:budget-statistic.revenue-incl-cost') }}:</b> {{ getRevenueInclCost() }}</v-col>
            <v-col><b>{{ $t('display/elevator:budget-statistic.freespace-ads') }}:</b> {{ getFreespaceAds() }}</v-col>
          </v-row>
        </v-col>

        <v-col cols="12" md="3">
          <v-row>
            <b>{{ $t('display/elevator:budget-statistic.yearly-revenue-incl-cost') }}</b>
          </v-row>
          <v-row>
            {{ getYearlyCost() }} €
          </v-row>
          <v-row>
            <v-spacer ></v-spacer>
          </v-row>
          <v-row>
            <b>{{ $t('display/elevator:budget-statistic.statistic-generated-at') }}</b>: {{ item.budgetStatistic.createdAt }}
          </v-row>
        </v-col>

      </v-row>

    </v-card-text>

  </v-card>
</template>

<script>
export default {
  name: "StatisticItem",
  props: {
    item: {}
  },
  data() {
    return {
      color: '',
      text: ''
    }
  },
  created() {
    if (this.item.budgetStatistic.revenue > this.item.budgetStatistic.monthlyCost * 1.2) {
      this.color = 'green';
      this.text = this.$t('display/elevator:budget-statistic.revenue-more-20');
    } else if (this.item.budgetStatistic.revenue > this.item.budgetStatistic.monthlyCost) {
      this.color = 'orange';
      this.text = this.$t('display/elevator:budget-statistic.revenue-less-20');
    } else {
      this.color = 'red';
      this.text = this.$t('display/elevator:budget-statistic.revenue-lover-monthly-cost');
    }
  },
  methods: {
    monthlyCost() {
      return this.item.budgetStatistic.monthlyCost != null
        ? this.item.budgetStatistic.monthlyCost.toLocaleString(undefined, { maximumFractionDigits: 2 })
          : '';
    },
    getRevenue() {
      return this.item.budgetStatistic.revenue != null
        ? this.item.budgetStatistic.revenue.toLocaleString(undefined, { maximumFractionDigits: 2 })
          : '';
    },
    getProvision() {
      return this.item.budgetStatistic.provision != null
        ? this.item.budgetStatistic.provision.toLocaleString(undefined, { maximumFractionDigits: 2 }) : '';
    },
    getInhouse() {
      let percentCustomer = 0.0;

      if (this.item.budgetStatistic.countCustomer > 0) {
        percentCustomer = (this.item.budgetStatistic.countCustomer
          / (this.item.budgetStatistic.countBudget
          + this.item.budgetStatistic.countCustomer
          + this.item.budgetStatistic.countFreespace) * 100)
          .toLocaleString(undefined, { maximumFractionDigits: 2 });
      }

      return percentCustomer;
    },
    getYearlyCost() {
      return this.item.yearlyRevenue != null
        ? this.item.yearlyRevenue.toLocaleString(undefined, { maximumFractionDigits: 2 }) : '~';
    },
    getRevenueInclCost() {
      let trueRevenue = '~';

      if (this.item.budgetStatistic.revenue != null && this.item.budgetStatistic.monthlyCost != null) {
        trueRevenue = (this.item.budgetStatistic.revenue
          - this.item.budgetStatistic.monthlyCost)
          .toLocaleString(undefined, { maximumFractionDigits: 2 });
      }

      return trueRevenue;
    },
    getBudgetAds () {
      let percentBudget = 0.0;

      if (this.item.budgetStatistic.countBudget > 0.0) {
        percentBudget = (this.item.budgetStatistic.countBudget
          / (this.item.budgetStatistic.countBudget
            + this.item.budgetStatistic.countCustomer
            + this.item.budgetStatistic.countFreespace) * 100)
          .toLocaleString(undefined, { maximumFractionDigits: 2 });
      }

      return percentBudget;
    },
    getFreespaceAds() {
      let percentFreespace = 0.0;

      if (this.item.budgetStatistic.countFreespace > 0.0) {
        percentFreespace = (this.item.budgetStatistic.countFreespace
          / (this.item.budgetStatistic.countBudget
            + this.item.budgetStatistic.countCustomer
            + this.item.budgetStatistic.countFreespace) * 100)
          .toLocaleString(undefined, { maximumFractionDigits: 2 });
      }

      return percentFreespace;
    }
  }
}
</script>
